import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { EMPTY } from '../../../../constants';

export function taxonomyAttributes({ channel, preview, selectedMenuItem }) {
  return {
    payload: Map({
      type: OPERATIONS[channel].TAXONOMY_ATTRIBUTES,
      value: Map({
        [selectedMenuItem]: Map({
          values: preview.getIn([selectedMenuItem, 'values'], EMPTY.LIST),
          valueIds: preview.getIn([selectedMenuItem, 'valueIds'], EMPTY.LIST),
          scaleId: preview.getIn([selectedMenuItem, 'scaleId']) || null,
        }),
      }),
    }),
  };
}
